// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3599 ? "e8d1d0e7" : chunkId) + "." + {"3599":"0d91a888bc82d2e4","7026":"f22429390855b6a0","9444":"6a31614cab01011a"}[chunkId] + ".js";
};